import { Link } from "react-router-dom";
import { Heart, ImageOff, Star } from "lucide-react";
import { formatPrice } from "../../lib/format";
import { getImageVariants } from "../../lib/imageVariants";
import useWishlistStore from "../../store/wishlistStore";

export default function ProductCard({ product }) {
  const inWishlist = useWishlistStore((s) => s.has(product.id));
  const toggleWishlist = useWishlistStore((s) => s.toggle);
  const { thumb, medium } = getImageVariants(product.images?.[0]?.url);

  return (
    <div className="group relative">
      <Link to={`/product/${product.slug}`} className="block">
        <div className="relative aspect-square overflow-hidden rounded-2xl bg-mono/[0.03] shadow-card">
          {medium ? (
            <img
              src={medium}
              srcSet={`${thumb} 200w, ${medium} 800w`}
              sizes="(min-width: 1024px) 22vw, 45vw"
              width={400}
              height={400}
              loading="lazy"
              alt={product.name}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center bg-mono/[0.05]">
              <ImageOff size={28} className="text-mono/20" />
            </div>
          )}
          {product.compareAtPrice && (
            <span className="absolute left-2 top-2 rounded-full bg-ink px-2.5 py-1 text-[10px] font-medium tracking-wide text-white">
              SALE
            </span>
          )}
        </div>
        <div className="mt-2.5 space-y-1">
          <h3 className="line-clamp-1 text-sm text-ink">{product.name}</h3>
          {product.reviewCount > 0 && (
            <div className="flex items-center gap-1 text-xs text-ink-light">
              <Star size={12} className="fill-gold-500 text-gold-500" />
              {product.rating.toFixed(1)}
              <span className="text-mono/30">({product.reviewCount})</span>
            </div>
          )}
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-ink">{formatPrice(product.price)}</span>
            {product.compareAtPrice && (
              <span className="text-xs text-ink-light line-through">
                {formatPrice(product.compareAtPrice)}
              </span>
            )}
          </div>
        </div>
      </Link>
      <button
        type="button"
        aria-label={inWishlist ? "Remove from wishlist" : "Add to wishlist"}
        onClick={() => toggleWishlist(product.id)}
        className="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full bg-white/90 shadow-sm backdrop-blur-sm transition-transform active:scale-90"
      >
        <Heart
          size={16}
          className={inWishlist ? "fill-gold-500 text-gold-500" : "text-ink-light"}
        />
      </button>
    </div>
  );
}
